import { FC, ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import NumberFormat, { NumberFormatProps } from "react-number-format";

import { defaultCurrency } from "constants/shared";

import { renderLabel } from "./helpers";
import { BaseInputProps } from "./types";
import {
  Container,
  Currency,
  ErrorContainer,
  InputBase,
  InputDescription,
  InputWrapper,
} from "./styles";

export type Props = {
  name?: string;
  onChange?: (value: string) => void;
  value?: string;
  label?: ReactNode | string;
  readOnly?: boolean;
  alwaysShowErrorBlock?: boolean;
  optional?: boolean;
  currency?: string;
} & NumberFormatProps &
  BaseInputProps;

const MoneyInput: FC<Props> = (props) => {
  const {
    className,
    label,
    error,
    onFocus,
    onBlur,
    readOnly,
    value,
    onChange,
    onKeyDown,
    alwaysShowErrorBlock = true,
    optional = false,
    currency,
    description,
    descriptionPosition,
    ...rest
  } = props;
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const isFloatingLabel = !props.readOnly && label && (isFocused || value);

  return (
    <Container
      className={`number-input money-input ${className} ${
        isFloatingLabel ? "with-floating-label" : ""
      } ${optional ? "optional" : ""}`}
    >
      <InputWrapper>
        <Currency>{currency || defaultCurrency}</Currency>
        <NumberFormat
          thousandSeparator={true}
          allowLeadingZeros={false}
          allowNegative={false}
          allowEmptyFormatting={true}
          customInput={InputBase}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onValueChange={({ value }) => onChange?.(value)}
          onKeyDown={onKeyDown}
          value={value}
          {...rest}
        />
        {renderLabel(label, optional)}
        {/*FIXME::: {optional && (
          <OptionalLabel>
            <Trans i18nKey={"common.input.optional"} />
          </OptionalLabel>
        )} */}
      </InputWrapper>
      {!!description && (
        <InputDescription className={`${descriptionPosition}`}>{description}</InputDescription>
      )}
      {(alwaysShowErrorBlock || error) && <ErrorContainer>{error} </ErrorContainer>}
    </Container>
  );
};

export default MoneyInput;
